// extracted by mini-css-extract-plugin
export default {"root":"ProjectCard_root__Ektfs","title":"ProjectCard_title__L+XRl","footer":"ProjectCard_footer__HQWZi","date":"ProjectCard_date__4SWKG"};